/**
 * @generated SignedSource<<8a4d3557ebfa68738e2f63426e09fe39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CloudProvider = "AWS" | "Azure" | "GCP" | "Kubernetes" | "TencentCloud" | "%future added value";
export type TriggerOrganizationScanInput = {
  orgs?: ReadonlyArray<OrganizationScanInput> | null | undefined;
};
export type OrganizationScanInput = {
  key: string;
  provider: CloudProvider;
};
export type TriggerOrganizationScanMutation$variables = {
  input: TriggerOrganizationScanInput;
};
export type TriggerOrganizationScanMutation$data = {
  readonly triggerOrganizationScan: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly scans: ReadonlyArray<{
      readonly uuid: any;
    }> | null | undefined;
  } | null | undefined;
};
export type TriggerOrganizationScanMutation = {
  response: TriggerOrganizationScanMutation$data;
  variables: TriggerOrganizationScanMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TriggerOrganizationScanMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TriggerOrganizationScanPayload",
        "kind": "LinkedField",
        "name": "triggerOrganizationScan",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountScan",
            "kind": "LinkedField",
            "name": "scans",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TriggerOrganizationScanMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TriggerOrganizationScanPayload",
        "kind": "LinkedField",
        "name": "triggerOrganizationScan",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountScan",
            "kind": "LinkedField",
            "name": "scans",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "abab82365f19dd3e51e8d72f369cec13",
    "id": null,
    "metadata": {},
    "name": "TriggerOrganizationScanMutation",
    "operationKind": "mutation",
    "text": "mutation TriggerOrganizationScanMutation(\n  $input: TriggerOrganizationScanInput!\n) {\n  triggerOrganizationScan(input: $input) {\n    scans {\n      uuid\n      id\n    }\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e776697921cb17aed1f17b27d6c46f4";

export default node;
